import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("h2", { class: "h5 mb-3" }, "Dodavatel", -1)
const _hoisted_2 = { class: "row d-flex align-items-end" }
const _hoisted_3 = { class: "col-lg-6 col-xl-4 col-xxl-3" }
const _hoisted_4 = { class: "fw-bold" }
const _hoisted_5 = { class: "mt-1" }
const _hoisted_6 = { class: "mt-1" }
const _hoisted_7 = { class: "mt-1" }
const _hoisted_8 = { class: "col-lg-6 col-xl-8 col-xxl-9 mt-3 mt-lg-0" }
const _hoisted_9 = {
  key: 0,
  class: "mt-1"
}
const _hoisted_10 = {
  key: 1,
  class: "mt-1"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _hoisted_1,
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.supplier.name), 1),
        _createElementVNode("div", _hoisted_5, _toDisplayString(_ctx.supplier.street), 1),
        _createElementVNode("div", _hoisted_6, _toDisplayString(_ctx.supplier.zip) + " " + _toDisplayString(_ctx.supplier.city), 1),
        _createElementVNode("div", _hoisted_7, _toDisplayString(_ctx.supplier.country), 1)
      ]),
      _createElementVNode("div", _hoisted_8, [
        _createElementVNode("div", null, "IČO: " + _toDisplayString(_ctx.supplier.companyId), 1),
        (_ctx.supplier.vatPayer)
          ? (_openBlock(), _createElementBlock("div", _hoisted_9, "DIČ: " + _toDisplayString(_ctx.supplier.vatId), 1))
          : (_openBlock(), _createElementBlock("div", _hoisted_10, "Neplátce DPH"))
      ])
    ])
  ], 64))
}